import store from '@/store'

export default {
  install(Vue) {
    const havePagePermission = (page) => {
      if (!page) return true
      if (!Vue.isLogged()) return false
      const permissions = store.state.userPermissions
      if (permissions && permissions[0] === 'mf/admin') return true

      const franchiseePermissionsRoutes = Object.entries(store.state.franchiseePermissionsRoutes).map(([key, value]) => value)
      const franchiseePermissionsKeyRoutes = Object.keys(store.state.franchiseePermissionsRoutes)

      if (Vue.getLoggedUser().is_franchisee && franchiseePermissionsRoutes.includes(page)) {
        const franchiseePermissions = store.state.franchiseePermissions
        const permissionKey = franchiseePermissionsKeyRoutes.find((key) => {
          return store.state.franchiseePermissionsRoutes[key] === page
        })
        return permissions && permissions.includes(page) && !franchiseePermissions[permissionKey] === false
      }

      return permissions && permissions.includes(page)
    }

    const haveParentPermission = (parent) => {
      if (!parent) return true
      if (!Vue.isLogged()) return false

      const permissions = store.state.userPermissions
      if (permissions && permissions[0] === 'mf/admin') {
        return true
      } else {
        return permissions.find((permission) => permission.split('/')[0] === parent)
      }
    }

    Vue.prototype.$havePagePermission = Vue.havePagePermission = havePagePermission
    Vue.prototype.$haveParentPermission = Vue.haveParentPermission = haveParentPermission

    Object.defineProperty(Vue.prototype, '$permissions', {
      get: () => ({
        havePagePermission,
        haveParentPermission,
      }),
    })

    Object.defineProperty(Vue, 'permissions', {
      get: () => {
        return {
          havePagePermission,
          haveParentPermission,
        }
      },
    })
  },
}
